import { render, staticRenderFns } from "./ItfPrintContent.vue?vue&type=template&id=c568e66c"
import script from "./ItfPrintContent.vue?vue&type=script&lang=js"
export * from "./ItfPrintContent.vue?vue&type=script&lang=js"
import style0 from "./ItfPrintContent.vue?vue&type=style&index=0&id=c568e66c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports